/**
 * When replacing innerHTML of an element, script tags are not executed. This function reruns the script tags.
 */
const reRunScripts = element => {
  Array.from(element.querySelectorAll('script')).forEach(oldScriptEl => {
    const newScriptEl = document.createElement('script');

    Array.from(oldScriptEl.attributes).forEach(attr => {
      newScriptEl.setAttribute(attr.name, attr.value);
    });

    const scriptText = document.createTextNode(oldScriptEl.innerHTML);
    newScriptEl.appendChild(scriptText);

    oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
  });
};

export default reRunScripts;
